export default __webpack_public_path__ + "static/media/tears-of-joy.a6c150a0.png";